import React, { useEffect, useState } from 'react'
import { Button, Flex, Spacer, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { DashboardProfile, DashboardRolesList, DashboardProfilesList } from '../../services/network'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as eva from 'eva-icons'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { ModifyDashboardProfileRoleModal } from '../ModifyDashboardProfileRoleModal/ModifyDashboardProfileRoleModal'

interface IDashboardProfileRoleProps {
  profile: DashboardProfile
  roles: DashboardRolesList
  setProfiles: React.Dispatch<React.SetStateAction<DashboardProfilesList | undefined>>
}

function DashboardProfileRole({ profile, roles, setProfiles }: IDashboardProfileRoleProps): JSX.Element {
  const { t } = useTranslation()
  const [isModifyProfileModalOpen, setIsModifyProfileModalOpen] = useState(false)
  const role = useSelector((state: RootState) => state.auth.role)

  useEffect(() => {
    eva.replace()
  }, [])

  return (
    <Flex
      background={'rgba(143, 155, 179, 0.16)'}
      flexDirection={'row'}
      gap={'14px'}
      padding={'16px'}
      justifyContent={'space-between'}
      alignSelf={'stretch'}
      borderRadius={'12px'}>
      <Text fontSize='16px' fontWeight='600' lineHeight='22.4px' alignContent={'center'}>
        {profile.firstName} {profile.lastName}
      </Text>
      <Text alignContent={'center'}>{profile.email}</Text>
      <Spacer></Spacer>
      <Text variant={'Pending'} alignContent={'center'}>
        {t(profile.role.title)}
      </Text>
      {role === process.env.REACT_APP_ROLE_ADMINISTRATOR && (
        <Button key={'modify'} onClick={(): void => setIsModifyProfileModalOpen(true)}>
          <i data-eva={'edit-2'} data-eva-fill={'#DD8B25'}></i>
        </Button>
      )}
      <ModifyDashboardProfileRoleModal
        isOpen={isModifyProfileModalOpen}
        onClose={(): void => {
          setIsModifyProfileModalOpen(false)
        }}
        dashboardProfileLoaded={profile}
        setIsModifyProfileModalOpen={setIsModifyProfileModalOpen}
        roles={roles}
        setProfiles={setProfiles}
      />
    </Flex>
  )
}

export { DashboardProfileRole }
